import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'

interface CampoAnaliticasProps {
  etiqueta: string
  tipo: string
  datos: { valor: string; count: number }[]
}

export function CampoAnaliticas({ etiqueta, datos }: CampoAnaliticasProps) {
  const total = datos.reduce((sum, d) => sum + d.count, 0)

  return (
    <Card className="border border-gray-300 dark:border-gray-700">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">{etiqueta}</CardTitle>
      </CardHeader>
      <CardContent>
        {datos.length > 0 ? (
          <>
            <ResponsiveContainer width="100%" height={Math.max(datos.length * 35, 120)}>
              <BarChart data={datos} layout="vertical" margin={{ left: 0, right: 20 }}>
                <XAxis type="number" hide />
                <YAxis type="category" dataKey="valor" width={120} tick={{ fontSize: 12 }} />
                <Tooltip formatter={(value: number) => [`${value} (${total > 0 ? Math.round((value / total) * 100) : 0}%)`, 'Respuestas']} />
                <Bar dataKey="count" fill="#14b8a6" radius={[0, 4, 4, 0]} />
              </BarChart>
            </ResponsiveContainer>
            <div className="mt-3 space-y-1">
              {datos.map((d) => (
                <div key={d.valor} className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground truncate max-w-[200px]">{d.valor}</span>
                  <span className="font-medium">
                    {d.count} ({total > 0 ? Math.round((d.count / total) * 100) : 0}%)
                  </span>
                </div>
              ))}
            </div>
          </>
        ) : (
          <p className="text-sm text-muted-foreground">Sin datos</p>
        )}
      </CardContent>
    </Card>
  )
}
